import React from 'react';
import { connect } from 'react-redux';
import { DBROMFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'
import { ROMComments } from './ROMComments'
import { ROMShoulderFunctionalER } from './ROMShoulderFunctionalER'
import { ROMShoulderFunctionalIR } from './ROMShoulderFunctionalIR'
import { ROMDigitOpposition } from './ROMDigitOpposition'

const components = {
    ROMComments,
    ROMShoulderFunctionalER,
    ROMShoulderFunctionalIR,
    ROMDigitOpposition
}


class PatientCareCenterNoteObjectiveROMPanel extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {

        switch (this.props.panel.MOPMPTNO) {
            case 1:
                return (
                    <div className={styles.textfield_row}>
                        <div className={styles.cell_wrapper}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.panelId} flagText={'ROM - ' + this.props.panel.MOPLABEL} />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <label title={this.props.normMsg} className={styles.label}>{this.props.panel.MOPLABEL}</label>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.arom_r} />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'AROM'}
                                className={styles.arom_c}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.arom_l} >
                                <span className={styles.prev_wrapper}>
                                    {this.props.prevArom}
                                </span>
                            </span>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.prom_arom_spacer} />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.prom_r} />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'PROM'}
                                className={styles.prom_c}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.prom_l} >
                                <span className={styles.prev_wrapper}>
                                    {this.props.prevProm}
                                </span>
                            </span>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className={styles.textfield_row}>
                        <div className={styles.cell_wrapper}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.panelId} flagText={'ROM - ' + this.props.panel.MOPLABEL} />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <label title={this.props.normMsg} className={styles.label} >{this.props.panel.MOPLABEL}</label>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'AROMR'}
                                className={styles.arom_r}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.arom_c} >
                                <span className={styles.prev_wrapper}>
                                    {this.props.prevAromR}
                                </span>
                            </span>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'AROML'}
                                className={styles.arom_l}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.arom_arom_spacer} >
                                <span className={styles.prev_wrapper}>
                                    {this.props.prevAromL}
                                </span>
                            </span>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'PROMR'}
                                className={styles.prom_r}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.prom_c} >
                                <span className={styles.prev_wrapper}>
                                    {this.props.prevPromR}
                                </span>
                            </span>
                        </div>
                        <div className={styles.cell_wrapper}>
                            <DBROMFieldObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVEROM'
                                entityKeyColumn='RONO'
                                min={this.props.panel.MOPMIN}
                                max={this.props.panel.MOPMAX}
                                entityKeyValue={this.props.rono}
                                field={this.props.panel.MOPCOLUMNPREFIX + 'PROML'}
                                className={styles.prom_l}
                            />
                        </div>
                        <div className={styles.cell_wrapper}>
                            <span className={styles.prev_wrapper}>
                                {this.props.prevPromL}
                            </span>
                        </div>

                    </div>
                );

            case 3:
                return this.renderChild(this.props.panel.MOPNAME, this.props.panel.MOPNO);

            default:
                return (
                    <div />
                );
        }
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];
    let flagged = false;
    let normMin = panel.MOPAROMNORMMIN;
    let normMax = panel.MOPAROMNORMMAX;
    let normMsg = '';

    if (normMin !== null && normMax != null) {
        if (normMin === normMax) {
            normMsg = 'Normative Value: ' + normMin;
        } else {
            normMsg = 'Normative Range: ' + normMin + ' - ' + normMax;
        }
    } else if (normMin !== null) {
        normMsg = 'Normative Range: Greater than or equal to ' + normMin;
    } else if (normMax !== null) {
        normMsg = 'Normative Range: Less than or equal to ' + normMax;
    }

    let prevProm = '';
    let prevArom = '';
    let prevPromR = '';
    let prevPromL = '';
    let prevAromR = '';
    let prevAromL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVEROMPREV[pk]) {
        if (panel.MOPMPTNO === 1) {
            prevProm = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'PROM'];
            prevArom = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'AROM'];
        }
        if (panel.MOPMPTNO === 2) {
            prevPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'PROMR'];
            prevPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'PROML'];
            prevAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'AROMR'];
            prevAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk][panel.MOPCOLUMNPREFIX + 'AROML'];
        }
    }

    if (panel.MOPMPTNO === 1 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 1 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML'] !== null &&
        String(state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML']).indexOf('*') !== -1) {
        flagged = true;
    } else if (panel.MOPMPTNO === 1 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 1 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 1 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROM'] > normMax) {
        flagged = true;
    } else if (panel.MOPMPTNO === 1 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROM'] > normMax) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROMR'] > normMax) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROMR'] > normMax) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMin !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML'] < normMin) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AROML'] > normMax) {
        flagged = true;
    } else if (panel.MOPMPTNO === 2 &&
        normMax !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML'] !== null &&
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'PROML'] > normMax) {
        flagged = true;
    }

    return {
        noteId,
        rono,
        panel,
        flagged,
        normMsg,
        prevProm,
        prevArom,
        prevPromR,
        prevPromL,
        prevAromR,
        prevAromL,
    };
}

const connectedPatientCareCenterNoteObjectiveROMPanel = connect(mapStateToProps)(PatientCareCenterNoteObjectiveROMPanel);
export { connectedPatientCareCenterNoteObjectiveROMPanel as PatientCareCenterNoteObjectiveROMPanel };


